import { ButtonBase, makeStyles } from '@material-ui/core';
import { map } from 'lodash';
import React from 'react';
import moment from 'moment';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import config from '../../preorder/configs/config';

const useStyle = makeStyles((theme) => ({
  root: {
    background: 'white',
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(1, 1),

    '& > *': {
      flexBasis: '50%',
      flexShrink: 0,
    },
  },
  buttonContainer: {
    padding: theme.spacing(1),
  },
  button: {
    background: 'transparent',
    borderRadius: 4,
    boxShadow: '0px 0px 6px rgba(0, 0, 0, .25)',
    display: 'flex',
    minHeight: 60,
    padding: theme.spacing(0, 1.5),
    width: '100%',
  },
  buttonIcon: {
    width: 30,
    height: 30,
    marginRight: theme.spacing(1),
  },
  buttonContent: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    width: '100%',
  },
  buttonTitle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  buttonDescription: {
    fontSize: 10,
  },
}));

export default function CampaignButtons({ data }) {
  const classes = useStyle();
  const history = useHistory();
  const { fridgeId } = useParams();
  const staticButton = [
    ...(config.BrandNameEN === 'FreeZone'
      && moment().utcOffset(8).isBetween(
        moment().utcOffset(8).set({ year: 2023, month: 8, date: 1 }).startOf('d'),
        moment().utcOffset(8).set({ year: 2023, month: 8, date: 30 }).endOf('d')
      )
      ? [{
        buttonIconUrl: 'MenuAd/edm.png',
        description: '88折起! 可於下方菜單直接購餐',
        id: '本檔型錄優惠',
        title: '本檔型錄優惠',
        onClick: () => {
          history.push('/activity/2023-moon-festival');
        },
      },
      ] : []),
    {
      buttonIconUrl: 'MenuAd/foodcountdown.png',
      description: '即期現貨優惠最低五折起！立刻點我查看',
      id: '倒數即食',
      title: '倒數即食',
      onClick: () => {
        history.push(`/menu/ad/flash_sale/${fridgeId}`);
      },
    },
  ];

  return (
    <div className={classes.root}>
      {map([...data, ...staticButton], (item) => {
        const {
          buttonIconUrl,
          description,
          id,
          onClick,
          title,
        } = item;

        return (
          <div className={classes.buttonContainer} key={id}>
            <ButtonBase className={classes.button} onClick={onClick}>
              {buttonIconUrl ? <img className={classes.buttonIcon} src={`${config.RESOURCE_URI}${buttonIconUrl}`} alt="" /> : null}
              <div className={classes.buttonContent}>
                <span className={classes.buttonTitle}>{title}</span>
                <span className={classes.buttonDescription}>{description}</span>
              </div>
            </ButtonBase>
          </div>
        );
      })}
    </div>
  );
}
